<template>
    <div class="card-item"
        v-if="isShowCategory"
        @click="clickCategory()">
        <div class="card-wrapper"
            :class="[{'card-mass': theme == 'mass'}, {'card-prestige': theme == 'prestige'}]"
            v-if="categoryType == 'cat'">
            <div class="card-img">
                <img :src="getCategoryImgUrl()" />
            </div>
            <div class="card-info"
                :class="{'card-info-quota': isShowQuota}">
                <div class="card-name">{{localeCode == 1033 ? category.name_en : category.name_th}}</div>
                <div class="card-quota"
                    v-if="isShowQuota">
                    <div v-if="getShowExpireDate()">{{getExpireDate()}}</div>
                    <div v-html="getQuota()"></div>
                </div>
            </div>
        </div>
        <div class="card-wrapper main-category-wrapper"
            v-if="categoryType == 'main'">
            <div class="card-img">
                <img :src="getCategoryImgUrl()" />
            </div>
        </div>
        <div class="card-wrapper info-category-wrapper"
            :class="[{'card-mass': theme == 'mass'}, {'card-prestige': theme == 'prestige'}]"
            v-if="categoryType == 'info'">
            <div class="card-img">
                <img :src="getCategoryImgUrl()" />
            </div>
            <div class="card-info"
                :class="{'card-info-quota': isShowAmbassadorDate}">
                <div class="card-name">{{localeCode == 1033 ? category.name_en : category.name_th}}</div>
                <div class="card-quota"
                    v-if="isShowAmbassadorDate">
                    <div>{{ambassadorStartDate}}</div>
                    <!-- <div v-html="ambassadorEndDate"></div> -->
                    <div>{{lbl.reward.end_date_lbl}}<span class="text-end-date">{{ambassadorEndDate}}</span></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import Moment from 'moment';
//helper
import Locale from '@/helper/locale/locale.js';
import Util from '@/helper/Utility.js';
export default {
    name: 'RewardCategoryItem',
    computed: {
        theme: function () {
            return this.$store.state.theme;
        },
        isAmbassador: function () {
            return this.$store.state.isAmbassador;
        },
        isInfoCategory: function () {
            return this.$store.getters.getIsInCategoryCardIds(this.category.id);
        }
    },
    props: {
        category: { type:Object, required: true },
        isAmbassadorCategory: { type:Boolean, required: true },
        isMainCategory: { type: Boolean, default: false }
    },
    data: function () {
        return {
            lbl: Locale.getLbl(),
            localeCode: Locale.getLocaleCode(),
            categoryType: 'cat', // main, cat, info
            isShowCategory: false,
            isShowQuota: false,
            isShowAmbassadorDate: false,
            ambassadorStartDate: null,
            ambassadorEndDate: null
        };
    },
    created: function () {
        this.initCategoryItem();
    },
    methods: {
        // init
        initCategoryItem: function () {
            if (this.isMainCategory) {
                this.categoryType = 'main';
                this.isShowCategory = true;
                return;
            }

            this.isShowCategory = (this.category.count > 0);
            if (!this.isShowCategory) return;
            if (this.category.quota) {
                if (this.isAmbassadorCategory) {
                    this.isShowCategory = true;

                    if (this.isInfoCategory && this.category.quota.AmbassadorPeriod) {
                        this.ambassadorStartDate = this.getAmbassadorDate(this.lbl.reward.start_date_lbl, this.category.quota.AmbassadorPeriod.Start);
                        this.ambassadorEndDate = this.getAmbassadorEndDate(this.category.quota.AmbassadorPeriod.End);

                        this.isShowAmbassadorDate = (this.ambassadorStartDate && this.ambassadorEndDate);
                    }
                    this.isShowQuota = this.getShowQuota();
                } else {
                    this.isShowQuota = this.getShowQuota();
                    // this.isShowCategory = (this.category.quota.Quota);
                    this.isShowCategory = true;
                }
            }

            if (this.isInfoCategory) this.categoryType = 'info';
        },
        //event
        clickCategory: function () {
            this.$emit('clickCategory', {
                isMainCategory: this.isMainCategory,
                category: this.category
            });
        },
        //util
        getAmbassadorDate: function (lbl, timestamp) {
            var result = Moment.unix(timestamp).utc();
            var year = Moment.unix(timestamp).utc().format('YYYY');
            if (this.localeCode === 1054)
                year = result.get('year') + 543;

            year = year.toString();
            var month = this.lbl.date.month_short[result.format('M') - 1];
            var day = result.format('DD');
            var date = `${day} ${month} ${year}`;

            return Util.stringFormat(lbl, date);
        },
        getAmbassadorEndDate: function (timestamp) {
            var result = Moment.unix(timestamp).utc();
            var year = Moment.unix(timestamp).utc().format('YYYY');
            if (this.localeCode === 1054)
                year = result.get('year') + 543;

            year = year.toString();
            var month = this.lbl.date.month_short[result.format('M') - 1];
            var day = result.format('DD');
            var date = `${day} ${month} ${year}`;

            return Util.stringFormat(date);
        },
        getCategoryImgUrl: function () {
            if (this.category.mode == 'all')
                return `${Vue.bzbsConfig.bzbsBlobUrl}${Vue.bzbsConfig.categoryConfig.menuCategoryImgUrl}${this.theme}/all`
            else
                return `${Vue.bzbsConfig.bzbsBlobUrl}${Vue.bzbsConfig.categoryConfig.menuCategoryImgUrl}${this.theme}/${this.category.id}`
        },
        getExpireDate: function () {
            if (!this.category.quota) return;

            var expireDate = this.category.quota.QuotaRefreshOn;
            var message = this.lbl.reward.expire_date;

            var result = Moment.unix(expireDate).utc();
            var year = Moment.unix(expireDate).utc().format('YYYY');
            if (this.localeCode === 1054)
                year = result.get('year') + 543;

            //year = year.toString().substring(2, 4);
            year = year.toString();
            var month = this.lbl.date.month_short[result.format('M') - 1];
            var day = result.format('DD');
            var date = `${day} ${month} ${year}`;

            return Util.stringFormat(message, date);
        },
        getQuota: function () {
            if (!this.category.quota) return;

            var quotaLbl = '';
            var cateName = this.category.name_th ;

            //#region tmp solution
            if (cateName.indexOf('บริการตรวจสุขภาพประจำปี') >= 0) {
                quotaLbl = this.lbl.reward.quota_year;
            } else if (cateName.indexOf('ห้องรับรองพิเศษ ณ สนามแข่งขันฟุตบอล') >= 0) {
                quotaLbl = this.lbl.reward.quota_season;
            } else if (cateName.indexOf('บริการรถลีมูซีน') >= 0) {
                quotaLbl = this.lbl.reward.quota_year_not_allies;
            } else if (cateName.indexOf('บริการรถกอล์ฟและด่านตรวจคนเข้าเมืองด่วนพิเศษ') >= 0) {
                quotaLbl = this.lbl.reward.quota_year_not_allies;
            } else if (cateName.indexOf('บัตรสมาชิก GAYSORN DIAMOND MEMBER') >= 0) {
                quotaLbl = this.lbl.reward.quota_life_time;
            } else if (cateName.indexOf('บัตรสมาชิก') >= 0) {
                quotaLbl = this.lbl.reward.quota_life_time;
            } else if (cateName.indexOf('บัตรสมาชิก VIZ BLACK CARD') >= 0) {
                quotaLbl = this.lbl.reward.quota_life_time;
            } else if (cateName.indexOf('บริการฟิตเนส') >= 0) {
                quotaLbl = this.lbl.reward.quota_month;
            } else if (cateName.indexOf('ห้องรับรองพิเศษ ณ สนามบิน') >= 0) {
                quotaLbl = this.lbl.reward.quota_year;
            } else if (cateName.indexOf('บัตรชมภาพยนตร์') >= 0) {
                quotaLbl = this.lbl.reward.quota_year;
            } else if (cateName.indexOf('Luxury private screen') >= 0) {
                quotaLbl = this.lbl.reward.quota_life_time;
            } else if (cateName.indexOf('บริการให้คำปรึกษากฎหมายและภาษีอากร') >= 0) {
                quotaLbl = this.lbl.reward.quota_per_hour;
            } else {
                this.isShowQuota = false;
                return;
            }
            //#endregion tmp solution
            let available = this.category.quota.Available >= 0 ? this.category.quota.Available : 0;

            return (quotaLbl) ? Util.stringFormat(quotaLbl, available) : '';
        },
        getShowExpireDate: function () {
            if (!this.category.quota) {
                return false;
            } else {
                return (this.category.quota.QuotaRefreshOn);
            }
        },
        getShowQuota: function () {
            if (this.category.quota) {
                // return (this.category.quota.Quota);
                return true;
            } else {
                return false;
            }
        }
    }
}
</script>
<style lang="scss" scoped>
@import "../share/card.scss";
.text-end-date {
    margin-left: 2px;
}
</style>
